import Vue from 'vue'
import QInput from 'quasar/src/components/input/QInput.js';

export default Vue.extend({
  mixins: [
    QInput
  ],

  props: ['hasEmoji'],

  methods: {
    __getControl(h) {
      const child = []

      if (this.$scopedSlots.beforeInput) {
        child.push(this.$scopedSlots.beforeInput())
      }

      if (this.$scopedSlots.input) {
        child.push([
          this.$scopedSlots.input()

        ])
      } else {
        child.push(
          h(this.isTextarea === true ? 'textarea' : 'input', {
            ref: 'input',
            staticClass: 'q-field__native q-placeholder',
            style: (!this.hasEmoji) ? this.inputStyle : [this.inputStyle, { fontFamily: 'Segoe UI Emoji' }],
            class: this.inputClass,
            attrs: this.inputAttrs,
            on: this.onEvents,
            domProps: this.type !== 'file'
              ? { value: this.__getCurValue() }
              : this.formDomProps
          })
        )
      }

      return child
    }
  }
})
